import { LoadBannersFirestoreRepository } from 'data/repositories/firebase/load-banners-firestore-repository';
import { LoadBannersRepository } from 'domain/repositories/load-banners-repository';
import { makeFirebaseFirestoreDatasource } from 'main/factories/datasources/firebase/firestore-datasource-factory';

export const makeLoadBannersFirestoreRepository = (): LoadBannersRepository => {
  return new LoadBannersFirestoreRepository(makeFirebaseFirestoreDatasource());
};
